import { useState, useRef, useCallback, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toLocaleLang } from '../../Common/home-common';
import { TandCText } from '../../BetSlip/LoginMenu';
import { SetLoginBusyStatus } from '../../BetSlip/LoginHooks';
import { LoginIncorrect } from '../../BetSlip/LoginBase';
import Header from '../../Header/Header';
import LangSelector from '../../Header/LangSelector';
import Footer from '../../Footer/Footer';
import Copyright from '../../Footer/Copyright';
import LoginLoading from '../../Common/ui-components/LoginLoading';
import useClickAway from '../../Common/hooks/useClickAway';
import { detectIncognito } from 'detectincognitojs';
import './index.scss';
import forgetpw from '../../../info/Include/images/forgetpw.svg';
import cookie from '../../../info/Include/images/cookie.svg';
import register from '../../../info/Include/images/register.svg';
import registerblue from '../../../info/Include/images/register-blue.svg';
import otheracc from '../../../info/Include/images/otheracc.svg';
import loginImg from '../../../info/Include/images/login-img-new.PNG';
import ewin from '../../../info/Include/images/eWin_new_logo_blue.svg';
import logo_ch from '../../../info/Include/images/logo_hkjc_ch.png';
import logo_en from '../../../info/Include/images/logo_hkjc_en.png';
import logo_ch_white from '../../../info/Include/images/logo_hkjc_ch_white.svg';
import logo_en_white from '../../../info/Include/images/logo_hkjc_en_white.svg';
import { timeoutPromise, useBreakpoint } from '../../Common/CommonHooks';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useBetSlipMsgQuery } from '../../Home/Data/SitecoreDataHooks';
import { GetOnlinePara } from '../../Common/ChannelParaFunc';
import { QueryConfig } from '../../Common/ConfigHelper';
import { clearLoginSessionStorage, getWhitelistAcc, callLogoutIbApi } from '../../BetSlip/LoginIBHooks';
import { isEoD, getOldUrl } from '../../Common/GlobalFunc';
import { initSsoLogin, setSsoLogout } from '../../BetSlip/SsoHook';
import { useWindowSize, delay } from '../../Common/CommonHooks';
import oldVersionLogo from '../../../info/Include/images/betslip_logo.svg';
import { LoginOTP } from '../../BetSlip/LoginOTP';
import { SecurityPin } from '../../BetSlip/SecurityPin';
import { TrustBrowser } from '../../BetSlip/TrustBrowser';
import ErrorPopup from '../../BetSlip/ErrorPopup';
import LoginErrorPopup from '../../BetSlip/LoginErrorPopup';
import { MissingMobile } from '../../BetSlip/MissingMobile';
import { useAdobeLaunch } from '../../Common/utils/adobeLaunch';
import { LogoutReminderPopupType } from '../../Common/constants';

const CustomScrollbars = (props) => (
    <Scrollbars
        autoHeight
        autoHeightMin={440}
        autoHeightMax={440}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        {...props}
    />
);

const Title = ({ isSpeedbet }) => {
    const { t } = useTranslation();
    return (
        <>
            {isSpeedbet ? (
                <>
                    <div className="title">{t('LB_LG_EPA')}</div>
                    <div className="title-hr" />
                </>
            ) : (
                <div className="ewin">
                    <img src={ewin} width={99} alt="" />
                </div>
            )}

            <div className="explanation">{t('LB_LG_EXP')}</div>
        </>
    );
};

const LoginInput = ({
    loginAccount,
    setLoginAccount,
    pwd,
    setPwd,
    checkAccountPwd,
    checkIsEod,
    APILoading,
    setLoginAPILoading,
    isUsernameReadOnly,
    isPwdReadOnly,
    isOnWhitelist
}) => {
    const { t } = useTranslation();
    const usenameRef = useRef();
    const pwdRef = useRef();
    const { isMobileSize } = useWindowSize();

    return (
        <>
            <span className="login-t">{t('LB_LG_IN')}</span>
            <div className="input-c">
                <input
                    type="text"
                    id="login-account-input"
                    ref={usenameRef}
                    value={loginAccount}
                    onChange={(e) => {
                        let value = e.target.value;
                        if (isMobileSize && e.target.getAttribute('data-init') == 1) {
                            if (e.nativeEvent.data != null) {
                                value = e.nativeEvent.data;
                            }
                            e.target.setAttribute('data-init', 0);
                        }
                        setLoginAccount(value);
                    }}
                    onFocus={(e) => {
                        if (isMobileSize) {
                            e.preventDefault();
                            e.target.setAttribute('data-init', 1);
                            e.target.setSelectionRange(10, 10);
                            setTimeout(function () {
                                e.target.setSelectionRange(10, 10);
                            });
                        }
                        usenameRef.current.setAttribute('placeholder', '');
                    }}
                    onBlur={() => {
                        usenameRef.current.setAttribute('placeholder', t('LB_BS_LOGIN_ACCOUNT_PLACEHOLDER'));
                    }}
                    placeholder={t('LB_BS_LOGIN_ACCOUNT_PLACEHOLDER')}
                    maxLength={15}
                    className="login-input usename"
                    disabled={APILoading || isUsernameReadOnly}
                    readOnly={isUsernameReadOnly}
                />
            </div>
            <div className="input-c">
                <input
                    ref={pwdRef}
                    id="login-password-input"
                    type="password"
                    value={pwd}
                    onChange={(e) => {
                        let value = e.target.value;
                        if (isMobileSize && e.target.getAttribute('data-init') == 1) {
                            if (e.nativeEvent.data != null) {
                                value = e.nativeEvent.data;
                            }
                            e.target.setAttribute('data-init', 0);
                        }
                        setPwd(value);
                    }}
                    onFocus={(e) => {
                        if (isMobileSize) {
                            e.preventDefault();
                            e.target.setAttribute('data-init', 1);
                            e.target.setSelectionRange(10, 10);
                            setTimeout(function () {
                                e.target.setSelectionRange(10, 10);
                            });
                        }
                        pwdRef.current.setAttribute('placeholder', '');
                    }}
                    onBlur={(e) => {
                        pwdRef.current.setAttribute('placeholder', t('LB_BS_LOGIN_PASSWORD_PLACEHOLDER'));
                    }}
                    placeholder={t('LB_BS_LOGIN_PASSWORD_PLACEHOLDER')}
                    maxLength={20}
                    disabled={APILoading || isPwdReadOnly}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            checkAccountPwd(loginAccount, pwd, isOnWhitelist);
                            pwdRef.current.setAttribute('placeholder', t('LB_BS_LOGIN_PASSWORD_PLACEHOLDER'));
                        }
                    }}
                    className="login-input password"
                    readOnly={isPwdReadOnly}
                />
            </div>
            <button
                className={`button login-button cta_yellow ${APILoading ? 'disabled' : ''}`}
                onClick={() => {
                    !APILoading && checkAccountPwd(loginAccount, pwd, isOnWhitelist);
                }}
            >
                {t('LB_SIGNIN')}
            </button>
        </>
    );
};

const Link = ({ isUsernameReadOnly, isSpeedbet, handleLogout }) => {
    const { t, i18n } = useTranslation();
    const lang = toLocaleLang(i18n.language);
    const haveAcc = `${window.globalConfig.WCIP_URL}/${lang}/associate?EP=BS`;
    const noAcc = `${window.globalConfig.SP_URL}/infomenu/${i18n.language}/register/applybet.asp`;
    const [show, setShow] = useState(false);
    const item1Ref = useRef(null);
    const { isMobileSize } = useWindowSize();
    const close = useCallback(() => {
        setShow(false);
    }, []);
    useClickAway(item1Ref, close);

    const { sendAdobeEvent } = useAdobeLaunch();

    return (
        <div className="link">
            {isUsernameReadOnly == false && (
                <div
                    ref={item1Ref}
                    className={`item item1 cursor-pointer ${show ? 'show' : ''} ${isMobileSize && 'mobile-item1'}`}
                    onClick={() => setShow(!show)}
                >
                    <>
                        <img src={show ? registerblue : register} alt="" />
                        <span className="pre">{(window.globalConfig.NEW_CIAM == window.CiamFlag.UseArkle)?t('LB_BS_ACTIVATE'):t('LB_BS_REGISTER')}</span>
                    </>

                    {show && (
                        <div className="tooltips">
                            <div
                                onClick={() => {
                                    window.location.href = haveAcc;
                                }}
                                dangerouslySetInnerHTML={{ __html: t('LB_LG_HAVE_ACC') }}
                            />
                            <div
                                onClick={() => {
                                    window.location.href = noAcc;
                                }}
                                dangerouslySetInnerHTML={{ __html: t('LB_LG_NO_ACC') }}
                            />
                        </div>
                    )}
                </div>
            )}
            <div
                className={`cursor-pointer ${
                    isUsernameReadOnly == true
                        ? `item item1 ${isMobileSize && 'mobile-item1'}`
                        : !isSpeedbet
                        ? 'itemExtra item'
                        : 'item item2'
                }`}
                onClick={() => {                    
                    sendAdobeEvent({
                        event: 'interaction',
                        interaction: { eventID: 'eWin_Cannot-login' }
                    });
                    window.location.href = t('LB_BS_LOGIN_ACCESS_LOCKED_URL');
                }}
            >
                <img src={forgetpw} alt="" />
                <span>{t('LB_BS_CANNOT_LOGIN')}</span>
            </div>

            {!isSpeedbet && !isUsernameReadOnly && (
                <div
                    className="item item3 cursor-pointer"
                    onClick={() => {
                        window.open(t('LB_THIRD_PARTY_COOKIE_HELP_LINK'), '_blank');
                       
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { download_file_url: t('LB_THIRD_PARTY_COOKIE_HELP_LINK') }
                        });
                    }}
                >
                    <img style={{ padding: '11px' }} src={cookie} alt="" />
                    <span>{t('LB_THIRD_PARTY_COOKIE_SETTING')}</span>
                </div>
            )}
            {isUsernameReadOnly == true && (
                <div
                    className="item item2 cursor-pointer"
                    onClick={async () => {
                        await callLogoutIbApi();
                        handleLogout();
                    }}
                >
                    <img src={otheracc} alt="" />
                    <span className="pre">{t('LB_BS_LOGIN_OTHER_ACCOUNT')}</span>
                </div>
            )}
        </div>
    );
};

const EWalletModal = (props) => {
    const { show, onHide, setPwd, setLoginAccount } = props;
    const { t } = useTranslation();

    return (
        <Modal
            backdrop="static"
            show={show}
            onHide={onHide}
            size="lg"
            dialogClassName="custom-modal answer-modal"
            aria-labelledby="answer-modal"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>{t('LB_BS_EWALLET_TITLE')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="login-answer-container">
                    <div className="login-answer-content">
                        <div className="forgot-answer">{t('LB_BS_EWALLET_DESC')}</div>
                        <div className="button-box">
                            <div
                                className="bsBgColor cta_brand"
                                onClick={() => {
                                    setLoginAccount('');
                                    setPwd('');
                                    onHide();
                                }}
                            >
                                {t('LB_BS_EWALLET_LATER')}
                            </div>
                            <div
                                className="cta_yellow ewallet_upgrade"
                                onClick={() => {
                                    setLoginAccount('');
                                    setPwd('');
                                    onHide();
                                    window.open(t('LB_BS_EWALLET_UPGRADE_URL'), '_blank');
                                }}
                            >
                                {t('LB_BS_EWALLET_UPGRADE')}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

const TCModal = (props) => {
    const { onHide } = props;
    const { t } = useTranslation();
    const { msgLoading, getBetSlipLoginTnC } = useBetSlipMsgQuery();

    let textData = '';
    if (!msgLoading) {
        textData = getBetSlipLoginTnC();
        if (textData === '') {
            onHide();
        }
    }

    return !msgLoading && textData !== '' ? (
        <Modal
            backdrop="static"
            {...props}
            size="lg"
            dialogClassName="custom-modal tc-modal"
            aria-labelledby="tc-modal"
            centered
        >
            <Modal.Header>
                <Modal.Title id="tc-modal">{t('LB_BS_LOGIN_TANDC')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <CustomScrollbars> */}
                    <div className="tc-content">
                        <TandCText textData={textData} />
                    </div>
                {/* </CustomScrollbars> */}
                <div className="button-c">
                    <button
                        className="button proceed-button"
                        onClick={() => {
                            onHide();
                        }}
                    >
                        {t('LB_BS_LOGIN_TANDCBTN')}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    ) : null;
};

const IncorrectModal = (props) => {
    const { loginIncorrectMsg, onHide, setShowLoginLockPopup } = props;
    const { t } = useTranslation();

    useEffect(() => {
        if (loginIncorrectMsg == 'CIAM_100002') {
            onHide();
            setShowLoginLockPopup(true);
        }
    }, [loginIncorrectMsg]);
    return (
        <>
            {loginIncorrectMsg !== 'CIAM_100002' && (
                <Modal
                    backdrop="static"
                    show={loginIncorrectMsg}
                    onHide={onHide}
                    dialogClassName="custom-modal incorrect-modal"
                    aria-labelledby="incorrect-modal"
                    centered
                    style={{ zIndex: 100001 }}
                    backdropClassName="incorrect-modal-backdrop"
                >
                    <Modal.Body>
                        <div className="incorrect-content">
                            {loginIncorrectMsg && (
                                <LoginIncorrect messageCode={loginIncorrectMsg} onClose={onHide} showClose={false} />
                            )}
                        </div>
                        <div className="button-c cancel-button-c">
                            <button
                                className="button cancel-button"
                                onClick={() => {
                                    onHide();
                                }}
                            >
                                {t('LB_CLOSE')}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const Ewin2Header = () => {
    const { t, i18n } = useTranslation();
    const breakpoint = useBreakpoint();
    return breakpoint === 'mobile' ? (
        <div className="Ewin2Header-m">
            <img src={i18n.language === 'en' ? logo_en_white : logo_ch_white} alt="" />
            <LangSelector />
        </div>
    ) : (
        <>
            <div className="Ewin2Header">
                <a
                    className={`old-version ${!window.globalConfig.ENABLE_OLD_SITE_LINK ? 'vsbHide' : ''}`}
                    href={getOldUrl(i18n.language)}
                >
                    <img src={oldVersionLogo} />
                    {t('LB_OLD_VERSION')}
                </a>
                <LangSelector />
            </div>
            <div className="logo-banner">
                <img src={i18n.language === 'en' ? logo_en : logo_ch} alt="" />
            </div>
        </>
    );
};

const Ewin2Footer = () => {
    return (
        <div className="Ewin2Footer">
            <Copyright />
        </div>
    );
};

const Login = ({ type = 'Speedbet', loginLogout, loginLogoutFR, login_shared_states }) => {
    const isSpeedbet = type === 'Speedbet';
    const { i18n, t } = useTranslation();
    const navigate = useNavigate();
    const [isUsernameReadOnly, setIsUsernameReadOnly] = useState(false);
    const [isPwdReadOnly, setIsPwdReadOnly] = useState(false);
    const [otp, setOtp] = useState('');
    const [pin, setPin] = useState('');
    const { isMobileSize } = useWindowSize();
    const [isOnWhitelist, setIsOnWhiteList] = useState(false);
    const {
        checkAccountPwd,
        loginAccount,
        setLoginAccount,
        accessToken,
        setIsShowCSLogoutDialog,
        setLogoutReminderPopupState,
        isShowTandC,
        setIsShowTandC,
        setShowUserInfo,
        showAnswerErrorMsg,
        showLogoutReminder,
        LoginAPILoading,
        setLoginAPILoading,
        showEwalletDialog,
        setShowEwalletDialog
    } = loginLogout;

    const {
        FR_loginWithUsernamePassword,
        FR_loginWithOTP,
        FR_loginWithPIN,
        FR_initStep,
        FR_TurstBrowser,
        FR_GetToken,
        FR_Logout,
        isShowOTPAuth,
        setIsShowOTPAuth,
        isShowSecurityPinAuth,
        setIsShowSecurityPinAuth,
        invalidOTP,
        setInvalidOTP,
        invalidPIN,
        setInvalidPIN,
        setIsShowTrustBrowser,
        isShowTrustBrowser,
        FR_GetMobile,
        FR_ResendOTP,
        showErrorPopup,
        setShowErrorPopup,
        setLoginIncorrectMsg,
        showLoginLockPopup,
        setShowLoginLockPopup,
        isShowOTPToast,
        setIsShowOTPToast,
        isMissingMobile,
        setIsMissingMobile,
        isVoiceOTP, 
        setIsVoiceOTP
    } = loginLogoutFR;

    const { pwd, setPwd, loginIncorrectMsg, closeLoginIncorrectMsg } = login_shared_states;
    const [isIncognito, setIsIncognito] = useState(false);

    const { sendAdobeEvent } = useAdobeLaunch();
    const [loadingStepOne, setLoadingStepOne] =useState(false)
    const [verifyOtpLoading, setVerifyOtpLoading] =useState(false)
    const [verifyPinLoading, setVerifyPinLoading] =useState(false)
    const [isSecurityPin, setIsSecurityPin] = useState(false);
    useEffect(() => {
        // re-init for OTP overlay
        setOtp('');
        setInvalidOTP(false);
    }, [isShowOTPAuth]);

    useEffect(() => {
        // re-init for Pin overlay
        setPin('');
        setInvalidPIN(false);
        if(isShowSecurityPinAuth) {
            setIsSecurityPin(true);
        }  
    }, [isShowSecurityPinAuth]);

    const ssoInit = async () => {
        //await FR_initStep();
        const data = await initSsoLogin();
        if (data != false) {
            setLoginAccount(data);
            if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseCiam) {
                setPwd('********');
                setIsPwdReadOnly(true);
            }
            setIsUsernameReadOnly(true);
            setShowUserInfo(true);
        } else {
            setIsUsernameReadOnly(false);
            setIsPwdReadOnly(false);
        }
    };

    useEffect(() => {
        if (window.globalConfig.NEW_LOGOUT_REMINDER_FLOW) {
            setLogoutReminderPopupState(LogoutReminderPopupType.closed);
        } else {
            setIsShowCSLogoutDialog(false);
        }
        
        !sessionStorage.getItem('setShowLogoutReminder') && ssoInit();
        sessionStorage.removeItem('setShowLogoutReminder');
        //FR_Logout().then(FR_initStep);
    }, []);

    const onClickCheckOTP = async () => {
        // loading
        // pop success or error message

        // reset state with async await
        setVerifyOtpLoading(true)
        setInvalidOTP('');
        await delay(1);
        await FR_loginWithOTP(otp);
        setVerifyOtpLoading(false)
    };

    const onClickCheckPin = async () => {
        // loading
        // pop success or error message
        setVerifyPinLoading(true)
        setInvalidPIN('');
        await delay(1);
        await FR_loginWithPIN(pin);
        setVerifyPinLoading(false)
    };

    const resetMyBetSlipLoginInfo = (obj) => {};

    const handleClickLogout = () => {
        SetLoginBusyStatus(false);
        ssoExpired();
        setIsUsernameReadOnly(false);
        setIsPwdReadOnly(false);
    };

    // otp overlay click Cancel
    const onClickCancelOTP = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsUsernameReadOnly(ssoWebId ? true : false);
        setIsPwdReadOnly(false);
        setIsShowOTPAuth(false);
        if (isMissingMobile) setIsMissingMobile(false);
    };

    const onClickCancelSecurityPin = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsUsernameReadOnly(ssoWebId ? true : false);
        setIsPwdReadOnly(false);
        setIsShowSecurityPinAuth(false);
    };

    const onClickCancelErrorPopup = (errorType) => {
        if (errorType == 'session timeout' || errorType == '100021') {
            const ssoWebId = window.sessionStorage.getItem('sso_web_id');
            setLoginAccount(ssoWebId ? ssoWebId : '');
            setPwd('');
            setIsShowOTPAuth(false);
            setIsShowSecurityPinAuth(false);
            setIsShowTrustBrowser(false);
        }
        setShowErrorPopup(false);
    };
    const onClickCancelLoginLockPopup = () => {
        const ssoWebId = window.sessionStorage.getItem('sso_web_id');
        setLoginAccount(ssoWebId ? ssoWebId : '');
        setPwd('');
        setIsShowOTPAuth(false);
        setShowLoginLockPopup(false);
        FR_initStep();
    };

    const handleCheckPassword = async () => {
        const loginAccountTrim = loginAccount.trim();
        setLoginAccount(loginAccountTrim);
        setLoginAPILoading(true);
        setLoadingStepOne(true)
        try {
            let isEod = await Promise.race([checkIsEod(), timeoutPromise()]);

            if (!isEod) {
                if (
                    window.globalConfig.NEW_CIAM == window.CiamFlag.UseWhitelist ||
                    window.globalConfig.NEW_CIAM == window.CiamFlag.UseArkle
                ) {
                    await loginWithNewCIAM(loginAccountTrim, pwd);
                } else {
                    await checkAccountPwd(loginAccountTrim, pwd, null);
                }
            }
        } catch (err) {
            console.log(err);
            if (err.message === 'Request timed out') {
                setLoginIncorrectMsg('TIMEOUT');
            } else {
                setLoginIncorrectMsg('OTHER');
            }
        }
        setLoadingStepOne(false)
        setLoginAPILoading(false);
    };

    const loginWithNewCIAM = async (loginAccount, password) => {
        // has empty
        if (!loginAccount || !password) {
            setLoginIncorrectMsg('100001');
            //loginStatus.isBusy = false;
            return;
        }

        window.sessionStorage.setItem('LoginWA', 'eWin_login');
        let isOnWhitelist;
        if (window.globalConfig.NEW_CIAM == window.CiamFlag.UseWhitelist) {
            isOnWhitelist = await getWhitelistAcc(loginAccount);
        } else {
            isOnWhitelist = true; //No need to call whitelist and set to true
        }
        setIsOnWhiteList(isOnWhitelist);
        if (isOnWhitelist === 'TIMEOUT') {
            console.debug('whitelist timeout, use ekba');
            //use ekba login if whitelist timeout
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_non-whitelist');
            await checkAccountPwd(loginAccount, password, false);
            //setLoginIncorrectMsg('TIMEOUT');
            //return;
        }
        if (isOnWhitelist) {
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_whitelist');
            const result = await FR_loginWithUsernamePassword(loginAccount, password);
            if (result == 'logout') {
                ssoExpired();
            }
        } else {
            window.sessionStorage.setItem('LoginWA', sessionStorage.getItem('LoginWA') + '_non-whitelist');
            await checkAccountPwd(loginAccount, password, false);
        }
    };

    const isSsoLogin = sessionStorage.getItem('sso_web_id')?.length > 0;

    const ssoExpired = () => {
        setIsUsernameReadOnly(false);
        setIsPwdReadOnly(false);
        setPwd('');
        setLoginAccount('');
        setSsoLogout();

        console.debug('11 clearStorageStatus')
        clearLoginSessionStorage();
    };

    useEffect(() => {
        detectIncognito().then((result) => {
            console.debug(result.browserName, result.isPrivate);
            setIsIncognito(result.isPrivate);
        });
    }, []);

    const closeCandTFn = () => {
        setIsShowTandC(false);
        if (accessToken) {
            setShowUserInfo(true);
            if (!isSpeedbet) {
                if (isIncognito) {
                    if (
                        !!window.sessionStorage.getItem('LoginWA') &&
                        window.sessionStorage.getItem('LoginWA').includes('WithMobile')
                    ) {                        
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: 'eWin_login_whitelistWithMobile_Incognito' }
                        });
                    } else if (
                        window.sessionStorage.getItem('LoginWA') &&
                        window.sessionStorage.getItem('LoginWA').includes('WithoutMobile')
                    ) {                        
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: 'eWin_login_whitelistWithoutMobile_Incognito' }
                        });
                    }
                } else {
                    if (
                        !!window.sessionStorage.getItem('LoginWA') &&
                        window.sessionStorage.getItem('LoginWA').includes('WithoutMobile')
                    ) {                       
                        sendAdobeEvent({
                            event: 'interaction',
                            interaction: { eventID: 'eWin_login_whitelistWithoutMobile' }
                        });
                    }
                }
            }    
            if(window.history.state.idx > 0) {
                navigate(-1);
            } else {
                navigate(`/${i18n.language}/racing`);
            }
        }
    };

    const closeEWallet = () => {
        setPwd('');
        setLoginAccount('');
        setShowEwalletDialog(false);
    };

    useEffect(() => {
        checkIsEodAsync();
    }, [sessionStorage.getItem('OOSMsgId')]);

    const checkIsEodAsync = async () => {
        await QueryConfig('channelParas', window.globalConfig.CHANNEL_PARA_URL);
        return setEodUi();
    };

    const checkIsEod = async () => {
        await QueryConfig('channelParas', window.globalConfig.CHANNEL_PARA_URL);
        return setEodUi();
    };

    const setEodUi = () => {
        if (isEoD()) {
            return true;
        } else {
            return false;
        }
    };

    const getEodMessage = () => {
        let message = GetOnlinePara(i18n.language === 'en' ? 'OOSEngContent' : 'OOSChiContent');
        if (message == null || message.length <= 0) {
            message = t('LB_BS_EOD');
        }
        return message;
    };

    const onClickTrustBrowser = async (trust) => {
        await FR_TurstBrowser(trust);
    };

    return (
        <div className={`GL login-page ${isSpeedbet ? 'isSpeedbet' : 'eWin2'}`}>
            {
                    loadingStepOne && <div className='loginLoading'>
                    <LoginLoading></LoginLoading>
                </div>
                }  
            <div id="eod">
                <div className={`eod ${isEoD() ? 'show' : ''}`}>
                    <div className="eod-msg">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: getEodMessage()
                            }}
                        ></div>
                    </div>
                </div>
            </div>
            {isSpeedbet ? <Header isSpeedbet={isSpeedbet} loginLogoutHook={loginLogout} /> : <Ewin2Header />}
            <div className="login-body">
                             
                <Title isSpeedbet={isSpeedbet} />
                <div className="login-c">
                    {isSpeedbet ? (
                        <div className="image">
                            <img src={loginImg} alt="" />
                        </div>
                    ) : null}
                    <div className="login">
                        <LoginInput
                            loginAccount={loginAccount}
                            setLoginAccount={setLoginAccount}
                            pwd={pwd}
                            setPwd={setPwd}
                            checkAccountPwd={handleCheckPassword}
                            checkIsEod={checkIsEod}
                            APILoading={LoginAPILoading}
                            setLoginAPILoading={setLoginAPILoading}
                            isUsernameReadOnly={isUsernameReadOnly}
                            isPwdReadOnly={isPwdReadOnly}
                            isOnWhitelist={isOnWhitelist}
                        />
                        {
                            <IncorrectModal
                                loginIncorrectMsg={loginIncorrectMsg}
                                onHide={closeLoginIncorrectMsg}
                                showClose={false}
                                setShowLoginLockPopup={setShowLoginLockPopup}
                            />
                        }
                    </div>
                </div>
                <Link isUsernameReadOnly={isUsernameReadOnly} isSpeedbet={isSpeedbet} handleLogout={handleClickLogout} />
                <TCModal show={isShowTandC} onHide={closeCandTFn} />
                <EWalletModal
                    show={showEwalletDialog}
                    onHide={closeEWallet}
                    setPwd={setPwd}
                    setLoginAccount={setLoginAccount}
                />
                {isShowOTPAuth && (
                    <LoginOTP
                        key={isShowOTPAuth.toString()} // Add a unique key to force re-render
                        showMsg={isShowOTPAuth}
                        onClickNext={onClickCheckOTP}
                        invalidOTP={invalidOTP}
                        setInvalidOTP={setInvalidOTP}
                        isMobile={isMobileSize}
                        otp={otp}
                        setOtp={setOtp}
                        setIsShowOTPAuth={setIsShowOTPAuth}
                        onClickCancelOTP={onClickCancelOTP}
                        closeBtnEnabled={false}
                        getMobile={FR_GetMobile}
                        resendOTP={FR_ResendOTP}
                        isShowOTPToast={isShowOTPToast}
                        setIsShowOTPToast = {setIsShowOTPToast}
                        setShowLoginLockPopup = {setShowLoginLockPopup}
                        isVoiceOTP = {isVoiceOTP}
                        setIsVoiceOTP = {setIsVoiceOTP}
                        verifyOtpLoading = {verifyOtpLoading}
                    />
                )}
                {isShowSecurityPinAuth && (
                    <SecurityPin
                        key={isShowSecurityPinAuth.toString()} // Add a unique key to force re-render
                        showMsg={isShowSecurityPinAuth}
                        onClickNext={onClickCheckPin}
                        invalidPIN={invalidPIN}
                        setInvalidPIN={setInvalidPIN}
                        pin={pin}
                        setPin={setPin}
                        onClickCancelSecurityPin={onClickCancelSecurityPin}
                        setShowLoginLockPopup = {setShowLoginLockPopup}
                        verifyPinLoading = {verifyPinLoading}
                        setShowErrorPopup = {setShowErrorPopup}
                    />
                )}
                {isShowTrustBrowser && (
                    <TrustBrowser 
                        showMsg={true} 
                        FR_TurstBrowser={onClickTrustBrowser} 
                        isShowTrustBrowser={isShowTrustBrowser} 
                        setIsShowTrustBrowser={setIsShowTrustBrowser} 
                        checkIsEod = {checkIsEod} 
                        isVoiceOTP = {isVoiceOTP}
                        setLoginIncorrectMsg = {setLoginIncorrectMsg}
                        isSecurityPin = {isSecurityPin}
                    />
                )}
                {isMissingMobile && (
                    <MissingMobile
                        onClickCancelOTP={onClickCancelOTP}
                        isMobile={isMobileSize}
                        isMissingMobile={isMissingMobile}
                    />
                )}
                {showErrorPopup && (
                    <ErrorPopup
                        errorType={showErrorPopup}
                        handleClickCancel={onClickCancelErrorPopup}
                        setShowErrorPopup={setShowErrorPopup}
                    />
                )}
                {showLoginLockPopup && (
                    <LoginErrorPopup
                        // errorType={showErrorPopup}
                        handleClickCancel={onClickCancelLoginLockPopup}
                        setShowErrorPopup={setShowLoginLockPopup}
                        closeLoginIncorrectMsg={closeLoginIncorrectMsg}
                    />
                )}
            </div>
            {/* {isSpeedbet ? <Footer /> : <Ewin2Footer />} */}
            {<Footer />}
        </div>
    );
};

export default Login;
